export const getBorderCrossingRouteKey = (fromId: number, toId: number) => `${fromId}:${toId}`;
